import { useTranslation } from 'react-i18next'

const HERO_IMAGE =
  'https://lh3.googleusercontent.com/aida-public/AB6AXuAUA7HegYrn4g1cPOZ6E0idisKRXcAK12u8C4bOq9Z8IhaP24eOvzBsSx_jhKqB8CuJv0HGr6tbxoPd0qBmR9CBUtmgBrzEGsrXhL8GrKwg1O-RRTE8w223QcHwd6NoOHwGti_CdQ0Yy5ELHdm8bDdBnQLkGrtOTsGbiStqSwwV0cRWLu_wvORMKH25_oiGZeFVL_9hcRFhhUkjaZ21pL8VEJsUXeVbqvh6BHGY6cY9E1feZezgusq9S7XuzD2mTF4KgtBscu3_EhJy'

export default function ManifestoHero() {
  const { t } = useTranslation()

  return (
    <>
      {/* Hero headline + quote */}
      <section className="px-5 sm:px-8 md:px-10 lg:px-12 max-w-[1440px] mx-auto mb-16 md:mb-32 pt-28 md:pt-40">
        <div className="flex flex-col md:flex-row gap-8 md:gap-16 lg:gap-20">
          <div className="w-full md:w-3/4">
            <span className="text-primary font-body text-xs uppercase tracking-[0.3em] mb-8 block">
              {t('manifesto.hero.subtitle')}
            </span>
            <h1 className="font-display text-3xl sm:text-5xl md:text-6xl lg:text-8xl font-extrabold tracking-tighter leading-[0.9] text-on-surface">
              {t('manifesto.hero.headingLine1')} <br />
              {t('manifesto.hero.headingLine2')}{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-primary-container">
                {t('manifesto.hero.headingHighlight')}
              </span>
            </h1>
          </div>
          <div className="w-full md:w-1/4 flex flex-col justify-end pb-4">
            <div className="border-l-2 border-primary pl-6 py-2">
              <p className="text-on-surface-variant text-sm leading-relaxed font-light italic">
                &ldquo;{t('manifesto.hero.quote')}&rdquo;
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Full-width architectural image with centered text */}
      <section className="w-full h-[300px] sm:h-[400px] md:h-[550px] lg:h-[716px] relative mb-16 md:mb-24 lg:mb-40">
        <div className="absolute inset-0 bg-surface-container-lowest overflow-hidden">
          <img
            alt="Monólito arquitetônico abstrato"
            className="w-full h-full object-cover opacity-40 mix-blend-luminosity"
            src={HERO_IMAGE}
          />
          <div className="absolute inset-0 bg-gradient-to-b from-surface via-transparent to-surface" />
        </div>
        <div className="relative h-full flex items-center justify-center px-5 sm:px-8 md:px-10 lg:px-12">
          <div className="max-w-4xl text-center">
            <p className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-light tracking-tight text-white/90 leading-tight">
              {t('manifesto.hero.statement')}
            </p>
          </div>
        </div>
      </section>
    </>
  )
}
